// extracted by mini-css-extract-plugin
export var accent = "_8m-4";
export var add = "_8m-j";
export var addIcon = "_8m-k";
export var deleteIcon = "_8m-i";
export var disabled = "_8m-9";
export var ellipsis = "_8m-f";
export var error = "_8m-3";
export var form = "_8m-5";
export var hideFocus = "_8m-2";
export var icon = "_8m-7";
export var input = "_8m-e";
export var listItem = "_8m-h";
export var mediumHeight = "_8m-b";
export var noBorder = "_8m-8";
export var noRadius = "_8m-1";
export var shortHeight = "_8m-a";
export var tallHeight = "_8m-c";
export var textInput = "_8m-0";
export var vertical = "_8m-g";
export var veryTallHeight = "_8m-d";
export var widget = "_8m-6";